<template>
  <main class="pubdetail-content-subsection">
    <div class="article-shell">
      <nav class="breadcrumb" aria-label="面包屑导航">
        <button type="button" @click="$router.push('/')">首页</button>
        <span class="dot" aria-hidden="true" />
        <button type="button" @click="$router.push('/pub')">云帆公告</button>
        <span class="dot" aria-hidden="true" />
        <span class="current">2026中考喜报</span>
      </nav>

      <header class="article-header">
        <p class="eyebrow">{{ eyebrow }}</p>
        <h1>{{ title }}</h1>
        <div class="article-meta">
          <time>{{ date }}</time>
          <span aria-hidden="true" />
          <p>云帆培优</p>
        </div>
        <p class="lead">{{ desc }}</p>
      </header>

      <section class="hero-collage" aria-label="2026中考喜报海报预览">
        <figure v-for="(image, index) in images" :key="image" class="collage-item">
          <img :src="image" :alt="title + '海报预览' + (index + 1)" />
          <figcaption>{{ collageLabels[index] }}</figcaption>
        </figure>
      </section>

      <section class="highlight-strip" aria-label="喜报亮点">
        <div v-for="highlight in highlights" :key="highlight.label" class="highlight-item">
          <strong>{{ highlight.value }}</strong>
          <span>{{ highlight.label }}</span>
        </div>
      </section>

      <section class="intro-card">
        <span class="quote-mark" aria-hidden="true">“</span>
        <p>{{ intro }}</p>
      </section>

      <section class="result-list" aria-label="2026中考成绩榜单">
        <article v-for="section in sections" :key="section.number" class="result-section">
          <div class="section-copy">
            <span class="section-number">{{ section.number }}</span>
            <p class="section-kicker">{{ section.kicker }}</p>
            <h2>{{ section.title }}</h2>
            <p class="section-desc">{{ section.desc }}</p>
            <div class="section-rule" />
            <p class="privacy-tip">海报姓名均已脱敏处理</p>
          </div>
          <figure class="poster-frame">
            <img
              :src="section.image"
              :alt="section.alt"
              :width="section.width"
              :height="section.height"
              loading="lazy"
              @load="notifyReady"
            />
            <figcaption>{{ section.title }} · 成绩为阶段性统计</figcaption>
          </figure>
        </article>
      </section>

      <footer class="article-closing">
        <div class="closing-icon" aria-hidden="true">✓</div>
        <h2>心有所向，步履不停</h2>
        <p>{{ closing }}</p>
        <div class="note">{{ note }}</div>
      </footer>
    </div>
  </main>
</template>

<script>
import { getAnnouncementById } from "../../../directus/api.js";

export default {
  name: "PubDetailContentSubsection",
  data() {
    return {
      title: "云帆公告",
      date: "",
      eyebrow: "YUNFAN ANNOUNCEMENT",
      desc: "",
      images: [],
      highlights: [],
      intro: "",
      sections: [],
      closing: "",
      note: "",
      collageLabels: ["中考总分榜", "数学高分榜", "物理高分榜"],
    };
  },
  mounted() {
    this.scheduleScrollReset();
    this.loadAnnouncement();
  },
  watch: {
    "$route.fullPath"() {
      this.loadAnnouncement();
    },
  },
  methods: {
    loadAnnouncement() {
      const id = this.$route && this.$route.query && this.$route.query.id;
      getAnnouncementById(id)
        .then((data) => {
          if (!data) return;
          this.title = data.title || this.title;
          this.date = data.date || this.date;
          this.eyebrow = data.eyebrow || this.eyebrow;
          this.desc = data.desc || "";
          this.images = Array.isArray(data.images) ? data.images : [];
          this.highlights = Array.isArray(data.highlights) ? data.highlights : [];
          this.intro = data.intro || "";
          this.sections = Array.isArray(data.sections) ? data.sections : [];
          this.closing = data.closing || "";
          this.note = data.note || "";
          document.title = `${this.title}｜云帆培优`;
          let description = document.querySelector('meta[name="description"]');
          if (!description) {
            description = document.createElement("meta");
            description.setAttribute("name", "description");
            document.head.appendChild(description);
          }
          description.setAttribute("content", this.desc);
          this.$nextTick(() => {
            this.scheduleScrollReset();
            this.notifyReady();
          });
        })
        .catch(() => this.$nextTick(() => {
          this.scheduleScrollReset();
          this.notifyReady();
        }));
    },
    resetScroll() {
      window.scrollTo(0, 0);
      document.documentElement.scrollTo(0, 0);
      document.body.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      const pageRoot = document.querySelector(".screen-wrapper");
      if (pageRoot) pageRoot.scrollIntoView({ block: "start" });
    },
    scheduleScrollReset() {
      this.resetScroll();
      window.setTimeout(() => this.resetScroll(), 0);
    },
    notifyReady() {
      this.$emit("ready");
    },
  },
};
</script>

<style scoped>
.pubdetail-content-subsection {
  background:
    radial-gradient(circle at 8% 8%, rgba(3, 146, 221, 0.08), transparent 24%),
    linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
  min-height: 900px;
  padding-bottom: 120px;
  position: relative;
  width: 1920px;
}

.article-shell {
  margin: 0 auto;
  padding-top: 50px;
  width: 1360px;
}

.breadcrumb {
  align-items: center;
  display: flex;
  gap: 14px;
  height: 30px;
}

.breadcrumb button,
.breadcrumb .current {
  background: transparent;
  border: 0;
  color: #52647c;
  font-family: "PingFang SC-Regular", Helvetica, sans-serif;
  font-size: 15px;
  line-height: 30px;
  padding: 0;
}

.breadcrumb button { cursor: pointer; }
.breadcrumb button:hover { color: #0392dd; }
.breadcrumb button:focus-visible { outline: 2px solid #0392dd; outline-offset: 3px; }
.breadcrumb .current { color: #0392dd; font-family: "PingFang SC-Medium", Helvetica, sans-serif; }
.dot { background: #b6c0cc; border-radius: 50%; height: 4px; width: 4px; }

.article-header {
  margin: 92px auto 0;
  text-align: center;
  width: 1120px;
}

.eyebrow {
  color: #ca3b22;
  font-family: "Poppins", Helvetica, sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 4px;
  margin: 0;
}

.article-header h1 {
  color: #00183c;
  font-family: "PingFang SC-Semibold", "PingFang SC", Helvetica, sans-serif;
  font-size: 52px;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 72px;
  margin: 24px 0 0;
}

.article-meta { align-items: center; display: flex; gap: 14px; justify-content: center; margin-top: 22px; }
.article-meta time,
.article-meta p { color: #8792a2; font-family: "PingFang SC-Regular", Helvetica, sans-serif; font-size: 15px; line-height: 24px; margin: 0; }
.article-meta span { background: #cdd4dc; border-radius: 50%; height: 4px; width: 4px; }
.lead { color: #42536a; font-family: "PingFang SC-Regular", Helvetica, sans-serif; font-size: 20px; line-height: 38px; margin: 40px auto 0; width: 1000px; }

.hero-collage {
  background: #77060c;
  box-shadow: 0 32px 90px rgba(67, 0, 5, 0.24);
  display: grid;
  gap: 5px;
  grid-template-columns: repeat(3, 1fr);
  height: 500px;
  margin-top: 70px;
  overflow: hidden;
  padding: 5px;
  position: relative;
}

.collage-item { height: 490px; margin: 0; overflow: hidden; position: relative; }
.collage-item::after { background: linear-gradient(180deg, transparent 52%, rgba(72, 0, 4, 0.9) 100%); bottom: 0; content: ""; left: 0; position: absolute; right: 0; top: 0; }
.collage-item img { height: 100%; object-fit: cover; object-position: top center; width: 100%; }
.collage-item figcaption { bottom: 118px; color: #fff5e4; font-family: "PingFang SC-Semibold", Helvetica, sans-serif; font-size: 22px; left: 30px; letter-spacing: 2px; position: absolute; z-index: 1; }

.highlight-strip {
  align-items: center;
  background: #ffffff;
  box-shadow: 0 20px 70px rgba(0, 24, 60, 0.12);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: 136px;
  margin: -48px auto 0;
  position: relative;
  width: 1120px;
  z-index: 2;
}

.highlight-item { align-items: center; border-right: 1px solid #e4e9ef; display: flex; gap: 18px; justify-content: center; }
.highlight-item:last-child { border-right: 0; }
.highlight-item strong { color: #c73620; font-family: "Poppins", Helvetica, sans-serif; font-size: 42px; font-weight: 600; line-height: 52px; }
.highlight-item span { color: #32465f; font-family: "PingFang SC-Medium", Helvetica, sans-serif; font-size: 17px; line-height: 26px; }

.intro-card {
  background: #f0f6fc;
  border-left: 5px solid #0b79c9;
  margin: 100px auto 0;
  min-height: 178px;
  padding: 44px 74px 40px 92px;
  position: relative;
  width: 1120px;
}

.quote-mark { color: rgba(11, 121, 201, 0.18); font-family: Georgia, serif; font-size: 110px; left: 28px; line-height: 1; position: absolute; top: 12px; }
.intro-card p { color: #263c57; font-family: "PingFang SC-Regular", Helvetica, sans-serif; font-size: 19px; line-height: 38px; margin: 0; position: relative; }

.result-list { margin: 120px auto 0; width: 1180px; }
.result-section { align-items: start; display: grid; gap: 80px; grid-template-columns: 300px 800px; margin-bottom: 140px; }
.section-copy { padding-top: 26px; position: sticky; top: 130px; }
.section-number { color: rgba(0, 24, 60, 0.08); font-family: "Poppins", Helvetica, sans-serif; font-size: 92px; font-weight: 600; line-height: 92px; }
.section-kicker { color: #c63b22; font-family: "Poppins", Helvetica, sans-serif; font-size: 13px; font-weight: 600; letter-spacing: 2.6px; margin: -11px 0 0; }
.section-copy h2 { color: #153f73; font-family: "PingFang SC-Semibold", Helvetica, sans-serif; font-size: 34px; font-weight: 600; line-height: 48px; margin: 14px 0 0; }
.section-desc { color: #53637a; font-family: "PingFang SC-Regular", Helvetica, sans-serif; font-size: 17px; line-height: 34px; margin: 24px 0 0; }
.section-rule { background: linear-gradient(90deg, #1598df, #075ec9); height: 4px; margin-top: 32px; width: 58px; }
.privacy-tip { color: #98a3b1; font-family: "PingFang SC-Regular", Helvetica, sans-serif; font-size: 13px; line-height: 24px; margin: 16px 0 0; }

.poster-frame { background: #ffffff; box-shadow: 0 26px 82px rgba(0, 24, 60, 0.13); margin: 0; padding: 18px 18px 0; }
.poster-frame img { display: block; height: auto; width: 100%; }
.poster-frame figcaption { color: #8b96a5; font-family: "PingFang SC-Regular", Helvetica, sans-serif; font-size: 14px; line-height: 56px; text-align: center; }

.article-closing {
  background: linear-gradient(135deg, #0b315f 0%, #061a38 100%);
  color: #ffffff;
  margin: 40px auto 0;
  padding: 64px 100px 56px;
  text-align: center;
  width: 1120px;
}
.closing-icon { align-items: center; background: rgba(255, 255, 255, 0.12); border: 1px solid rgba(255, 255, 255, 0.25); border-radius: 50%; display: flex; font-size: 24px; height: 54px; justify-content: center; margin: 0 auto; width: 54px; }
.article-closing h2 { font-family: "PingFang SC-Semibold", Helvetica, sans-serif; font-size: 32px; font-weight: 600; letter-spacing: 2px; line-height: 48px; margin: 22px 0 0; }
.article-closing > p { color: rgba(255, 255, 255, 0.82); font-family: "PingFang SC-Regular", Helvetica, sans-serif; font-size: 17px; line-height: 34px; margin: 22px auto 0; width: 820px; }
.note { border-top: 1px solid rgba(255, 255, 255, 0.16); color: rgba(255, 255, 255, 0.52); font-family: "PingFang SC-Regular", Helvetica, sans-serif; font-size: 13px; line-height: 24px; margin-top: 34px; padding-top: 22px; }
</style>
